import { useFeatureFlagEnabled as usePostHogFeatureFlagEnabled } from "posthog-js/react";

/**
 * Fail closed while flags are loading or PostHog is unavailable.
 * Use the exact key from the PostHog dashboard — keys are not auto-camelCased.
 */
export function useFeatureFlagEnabled(flag: string): boolean {
  return usePostHogFeatureFlagEnabled(flag) === true;
}
